import { render } from "./CreatePartnerPage.vue?vue&type=template&id=6fff31e9"
import script from "./CreatePartnerPage.vue?vue&type=script&lang=js"
export * from "./CreatePartnerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__